import React, {useEffect, useState} from "react";
import {Button} from "../../../../index";
import {useViewerStore} from "../../../../../store/store";
import {Input, Select} from "antd";
import { saveBuildingData } from "../../../../../pages/Editor/Views/BuildingAttributes/BuilderAtributesTab";
import {MasterDataOptionItem, RoofMesh} from "../../../../../@types/types";
const {Option} = Select;

export const QUESTIONABLE_ROOF_OPTION_OTHER_NOTES_ID = 7;

interface QuestionableRoofProps {
    roof: RoofMesh;
    noteId?: number | null;
    otherReason?: string;
    onSubmit?: (success: boolean, selectedQnRoofId: number, otherReasonInput: string) => void;
}

export const QuestionableRoof: React.FC<QuestionableRoofProps> = ({roof, noteId, otherReason, onSubmit}) => {

    const {sceneViewer, masterDataList, siteBuildingData, designList } = useViewerStore();

    const [selectedQnRoofId, setSelectedQnRoofId] = useState<number>(0)
    const [otherReasonInput, setOtherReasonInput] = useState<string>('')
    const [buildingIdx, setBuildingIdx] = useState<number | null>(null)
    const [roofIdx, setRoofIdx] = useState<number | null>(null)

    const defaultOption = { value: 0, disabled: true, label: "Select Reason" };
    const options : MasterDataOptionItem[] = [defaultOption, ...(masterDataList?.QuestionableRoof ?? [])];

    useEffect(() => {
        if (!roof) {
            sceneViewer.removeViewerAlert();
            alert('No selected roofs');
            return
        }


        setOtherReasonInput(String(otherReason));

        const note = roof.userData.questionableRoof
        const qnRoofId = noteId ?? (note ? (options.find(item=> item.label === note)?.value ?? 0) : 0);
        setSelectedQnRoofId(qnRoofId);
        siteBuildingData.forEach((building, bIdx) => {
            building.Roofs.forEach((data, rIdx) => {
                if (data.Designation === `R${roof.userData.roof_tag_id}`) {
                    setBuildingIdx(bIdx);
                    setRoofIdx(rIdx);
                    return;
                }
            });
        })

    }, [])
    
    
    const submitQuestionableRoof = () => {

        if (selectedQnRoofId === 0) {
            alert('Please select a reason');
            return
        }

        let roofNote = options[selectedQnRoofId].label;
        if ( roofNote === 'Other (See Notes)' && otherReasonInput === '') {
            alert('Please input a reason');
            return
        }


        roof.userData.questionableRoof = roofNote;
        roof.userData.questionableRoofId = selectedQnRoofId;


        if(selectedQnRoofId === QUESTIONABLE_ROOF_OPTION_OTHER_NOTES_ID){
            roof.userData.questionableRoofNotes = otherReasonInput
        }


        if (buildingIdx !== null && roofIdx !== null) {
            roof.Questionable_Roof_Id = selectedQnRoofId;
            let newDesignData = designList;
            newDesignData[0].Buildings[buildingIdx].Roofs[roofIdx].Questionable_Roof = true;
            newDesignData[0].Buildings[buildingIdx].Roofs[roofIdx].Questionable_Roof_Id = selectedQnRoofId;
            if(selectedQnRoofId === QUESTIONABLE_ROOF_OPTION_OTHER_NOTES_ID){
                newDesignData[0].Buildings[buildingIdx].Roofs[roofIdx].Questionable_Roof_Notes = otherReasonInput;
                onSubmit?.(true, selectedQnRoofId, otherReasonInput);
            }
            else {
                newDesignData[0].Buildings[buildingIdx].Roofs[roofIdx].Questionable_Roof_Notes = "";
                onSubmit?.(true, selectedQnRoofId, "");
            }

            if (!onSubmit) {
                saveBuildingData(newDesignData);
            }

        }
        useViewerStore.setState(state =>({refreshQuestionableRoof: !state.refreshQuestionableRoof}));
        sceneViewer.removeViewerAlert();
    }

    return (
        <>
            <div className={'treeForm'}>
                <label htmlFor="moveSelectedModuleByMeasurementSelectDir">Select Reason : </label>
                <br/>
                <Select
                    id="questionableRoofOptions"
                    value= {selectedQnRoofId}
                    onChange={setSelectedQnRoofId}
                >
                    {options.map((option) => (
                        <Option key={option.key} value={option.value} disabled={option.disabled} >
                            {option.label}
                        </Option>
                    ))}
                </Select>

                <br/>


                {

                    options[selectedQnRoofId].label === "Other (See Notes)" &&

                    <Input
                        id={"otherReasonInput"}
                        type="text"
                        value={otherReasonInput}
                        onChange={(e) => setOtherReasonInput(e.target.value)}
                        placeholder={"Input Reason Here"}
                        addonBefore={'Enter Notes'}
                        name="otherReason"
                    />

                }


                <br/>
                <Button
                    id={"submitQuestionableRoofBtn"}
                    variant="btn-primary"
                    size="btn-md"
                    className="editor__control--finalize modal-confirm-button"
                    onClick={submitQuestionableRoof}
                >
                    Submit
                </Button>

            </div>

        </>
    )
}

export const unsetQuestionableRoof = (roof : RoofMesh) => {
    const { sceneViewer, siteBuildingData, designList } = useViewerStore.getState();
if (!roof) return alert('No selected roofs');
    roof.userData.questionableRoof = "";
    roof.userData.questionableRoofId = 0;
    siteBuildingData.forEach((building, bIdx) => {
        building.Roofs.forEach((data, rIdx) => {
            if (data.Designation === `R${roof.userData.roof_tag_id}`) {
                let newDesignData = designList;
                newDesignData[0].Buildings[bIdx].Roofs[rIdx].Questionable_Roof = false;
                newDesignData[0].Buildings[bIdx].Roofs[rIdx].Questionable_Roof_Id = null;
                newDesignData[0].Buildings[bIdx].Roofs[rIdx].Questionable_Roof_Notes = ""
                saveBuildingData(newDesignData);
            }
        });
    })
    useViewerStore.setState(state =>({refreshQuestionableRoof: !state.refreshQuestionableRoof}));
    sceneViewer.removeViewerAlert();
} 